export default {
  namespaced: true,
  state: {
    materials: [],
    count: 0,
  },
  getters: {
    materials: (state) => state.materials,
    count: (state) => state.count,
  },
  mutations: {
    materials: (state, payload) => (state.materials = payload),
    count: (state, payload) => (state.count = payload),
  },
  actions: {
    list({ commit }, queryParams) {
      return this.$apiService
        .get("/materials", {
          params: queryParams,
        })
        .then((res) => {
          commit("materials", res?.data?.data ?? []);
          commit("count", res?.data?.total ?? 0);
          return res;
        });
    },
    store({}, payload) {
      return this.$apiService.post("/materials", payload);
    },
    update({}, { materialId, data }) {
      return this.$apiService.put(`/materials/${materialId}`, data);
    },
    destroy({}, materialId) {
      return this.$apiService.delete(`/materials/${materialId}`);
    },
  },
};

